import React, { useContext, useEffect } from 'react';
//@ts-ignore
import { UcAdminDetails } from "../../common/UcAdminDetails";
import { PageAction, PageContext, PageState } from '../../../lib/PageProvider';
import { useParams } from "react-router-dom";
//@ts-ignore
import { EnsureUser } from '../../auth/EnsureUser';
//@ts-ignore
import { useHasPermission } from 'components/auth/PermissionApiEndpoint';
//@ts-ignore
import { RoleUserList } from 'components/adminUc/Roles/RoleUserList';
//@ts-ignore
import { UserAccountList } from 'components/admin/Users/UserAccountList';
//@ts-ignore
import { UserMeterList } from 'components/admin/Users/UserMeterList';
//@ts-ignore
import { MeterRateList } from 'components/admin/Customers/MeterRateList';
//@ts-ignore
import { MeterCycleListPage } from 'components/admin/Billings/MeterCycleListPage';
import { useTranslation } from 'react-i18next';
import { UserActivityLogPage } from 'components/admin/Users/UserActivityLogPage';
import { User } from '../../admin/Users/User.interfaces';

interface UserDetailsPageProps {
    user: User;
    roleType: string;
}

export const UserDetailsPage = (props: UserDetailsPageProps) => {
    const { user } = props;
    const { t } = useTranslation();
    const { userId: urlUserId } = useParams();
    const userId: number = urlUserId ? parseInt(urlUserId) : user.id;

    const [pageState, pageDispatch] = useContext<[PageState, React.Dispatch<PageAction>]>(PageContext);

    useEffect(() => {
        pageDispatch({
            header: t("User Details") + t("Required"),
            actionItems: [] as any[],
            variableHeader: "",
            tabs: [],
            onTabChange: () => { },
            tabValue: ''
        });
    }, [pageState.header, pageDispatch, t]);


    let detailsRender = <></>;
    let tabs = [
        {
            title: t("Roles"),
            contentRender: <RoleUserList userId={userId} />,
            //residential users should not have access to this tab
            isHidden: !useHasPermission("RoleUser:Read") || props.roleType==="UtilityResidential"
        },
        {
            title: t("Accounts"),
            contentRender: <UserAccountList userId={userId} user={props.user} />,
            isHidden: !useHasPermission("UserAccount:Read")
        },
        {
            title: t("Meters"),
            contentRender: <UserMeterList userId={userId} />,
            isHidden: !useHasPermission("UserAccount:Read")
        },
        {
            title: t("Meter Rates"),
            contentRender: <MeterRateList userId={userId} />,
            isHidden: !useHasPermission("MeterRate:Read")
        },
        {
            title: t("Meter Billing Cycle"),
            contentRender: <MeterCycleListPage userId={userId} />,
            isHidden: !useHasPermission("MeterCycle:Read")
        },
        {
            title: t("Activity Log"),
            contentRender: <UserActivityLogPage userId={userId} email={props.user.email} lockoutEnd={user?.lockoutEnd} />,
            isHidden: !useHasPermission("UserAccessStats:Read")
        },
    ];

    return (
        <EnsureUser permissions={["User:Read"]}>
            <UcAdminDetails
                detailsRender={detailsRender}
                tabs={tabs}
                tabInitValue={
                    (props.roleType !== "UtilityResidential") ? (
                        t("Roles")
                    ) : (
                        t("Accounts")
                    )
                }
            />
        </EnsureUser>
    );
};